import * as React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { Button, Container, Grid2 } from '@mui/material';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAltOutlined';
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import "./customerSurvey.css";
import Footer from './Footer';

const StyledRating = styled(Rating)(({ theme }) => ({
    '& .MuiRating-iconEmpty .MuiSvgIcon-root': {
        color: theme.palette.action.disabled,

    },
}));

const customIcons = {
    1: {
        icon: <SentimentVeryDissatisfiedIcon color="error" sx={{ fontSize: 65 }} />,
        label: 'Very Dissatisfied',
    },
    2: {
        icon: <SentimentDissatisfiedIcon color="error" sx={{ fontSize: 65 }} />,
        label: 'Dissatisfied',
    },
    3: {
        icon: <SentimentSatisfiedIcon color="warning" sx={{ fontSize: 65 }} />,
        label: 'Neutral',
    },
    4: {
        icon: <SentimentSatisfiedAltIcon color="success" sx={{ fontSize: 65 }} />,
        label: 'Satisfied',
    },
    5: {
        icon: <SentimentVerySatisfiedIcon color="success" sx={{ fontSize: 65 }} />,
        label: 'Very Satisfied',
    },
};

function IconContainer(props) {
    const { value, ...other } = props;
    return <span {...other}>{customIcons[value].icon}</span>;
}

IconContainer.propTypes = {
    value: PropTypes.number.isRequired,
};


function CustomerSurvey() {

    const [text, setText] = React.useState("");
    const [fifthQ, setFifthQ] = React.useState(0);
    const [ratingValue, setRatingValue] = React.useState(0);
    const [isSubmitted, setIsSubmitted] = React.useState(false);
    const [loading, setLoading] = React.useState();
    const [responseMessage, setResponseMessage] = React.useState();
    const [recFrom, setRecFrom] = React.useState();
    const [email, setEmail] = React.useState();
    const currentDate = new Date().toISOString();

    // Function to set a cookie
    const setCookie = (name, value, days) => {
        const expires = new Date();
        expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
    };

    // Function to get a cookie
    const getCookie = (name) => {
        const cookies = document.cookie.split("; ");
        const cookie = cookies.find((row) => row.startsWith(name + "="));
        return cookie ? cookie.split("=")[1] : null;
    };


    React.useEffect(() => {
        // Check if the name is already stored in cookies
        let storedName = getCookie("firstName");
        let storedEmail = getCookie("emailAddress");

        if (!storedName) {
            // If not, get the name from the URL query parameter
            const urlParams = new URLSearchParams(window.location.search);
            const userName = urlParams.get("name");

            if (userName) {
                setCookie("firstName", userName, 365); // Store name in cookie
                storedName = userName;
            }
        }

        if (storedName) {
            setRecFrom(storedName);
        }


        if (!storedEmail) {

            const urlParams = new URLSearchParams(window.location.search);
            const emailAddress = urlParams.get("email");

            if (emailAddress) {
                setCookie("emailAddress", emailAddress, 365); // Store name in cookie
                storedEmail = emailAddress;
            }
        }

        if (storedEmail) {
            setEmail(storedEmail);
        }

    }, []);

    const deleteCookie = (name) => {
        setCookie(name, null, null)
      }



    const handleReviewSubmit = async () => {

        try {
            const response = await axios.post('https://centerprism.biz/prismqueryservice/Mobile/submitreview', {


                "receiveddate": currentDate,
                "source": "Mobile",
                "customernumber": "AARONFIT0001   ",
                "receivedfrom": recFrom,
                "receivedfromemail": email,
                "technician": "cpadmin",
                "servicecall": 0,
                "note": text,
                "surveysentdate": currentDate,
                "actionid": "Call2",
                "stars": fifthQ
            },
                {
                    headers: {
                        userName: "cpadmin",
                        siteId: "warehouse",
                        deviceId: "Mobile",
                    },
                });


    
            alert('user review submitted successfully!')
        } catch (error) {
            // Log the full error for debugging (optional)
            console.error(error);
            alert(error)

            // Set a user-friendly error message

        } finally {

        }


    };

    const handleSubmit = (event) => {
        setIsSubmitted(true);
        if (fifthQ === 0) {
            // Do not submit the form, show error
            alert('Please select the rating');
        } else if (fifthQ >= 1 && fifthQ <= 4) {
            // Proceed with form submission
            navigate("/SuccessPage");
        } else if (fifthQ === 5) {
            navigate("/google-review")
        }

    };

    const handleChange = (event) => {
        setText(event.target.value);
    };

    const navigate = useNavigate();
    return (
        <div id='customer-survey'>
            <div id='fi-q'>
                <div className='left-side'>

                    <p className='content-1'>1. How would you rate your service experience?</p>
                    <Rating
                        className='stars'
                        name="simple-controlled"
                        value={fifthQ}
                        onChange={(event, newValue) => {
                            setFifthQ(newValue);
                        }}
                        sx={{
                            // Change the color of filled stars
                            '& .MuiRating-iconFilled': {
                                color: '#4341F9', // Custom color for filled stars
                            },
                            // Change the color of empty stars
                            '& .MuiRating-iconEmpty': {
                                color: '#4341F9', // Custom color for empty stars
                            },
                            // Change the color of hover stars
                            '& .MuiRating-iconHover': {
                                color: '#4341F9', // Custom color on hover
                            },
                            fontSize: 60
                        }}
                    />
                </div>
                <textarea cols="50" rows="2" type='text' onChange={handleChange} placeholder='Please type your feedback here'
                    className='lg:py-4 lg:px-4  lg:w-[40rem] lg:h-[4rem]  outline-none' />
                <hr />
            </div>
            <div className='btn-cov'>
                <Button
                    id='form-btn'
                    onClick={() => {
                        handleReviewSubmit();
                        handleSubmit();
                    }} variant="contained">SUBMIT</Button>
            </div>
            <Footer/>
        </div>
    )
}

export default CustomerSurvey

